import cn from "classnames"

interface Props {
    className?: string
}

export function Line({ className }: Props) {
    return <hr className={cn("mobile-navigation__line", className)} />
}
